module.exports = __webpack_public_path__ + "static/media/magnifyingGlass.5bad38af.svg";